export const formValidate = (errors, touched, field) => {
  if (field in errors) {
    return "is-invalid";
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (field in touched) {
      return "is-valid";
    } else {
      return "";
    }
  }
};

export const formConvertErrorMessage = (message = "", t) => {
  // If [t] not a Function
  if (typeof t !== "function") {
    return message;
  }

  let result = message;
  const msgLowerCase = message.toLowerCase();

  if (msgLowerCase.includes("already been taken")) {
    result = t("common:validate.msg_duplicate");
  } else if (msgLowerCase.includes("please correct your data")) {
    result = t("common:validate.msg_correct_data");
  } else if (msgLowerCase.includes("effective time must be greater than")) {
    result = t("common:validate.msg_effective_greater");
  } else if (msgLowerCase.includes("the file does not exists")) {
    result = t("common:validate.msg_file_not_found");
  }

  return result;
};
